import { render, staticRenderFns } from "./DatosAbonoComponent.vue?vue&type=template&id=06156c89&scoped=true"
import script from "./DatosAbonoComponent.vue?vue&type=script&lang=js"
export * from "./DatosAbonoComponent.vue?vue&type=script&lang=js"
import style0 from "./DatosAbonoComponent.vue?vue&type=style&index=0&id=06156c89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06156c89",
  null
  
)

export default component.exports